import React, { useMemo, useState } from "react";
import { useUnreadCourseNotificationCount } from "../../query/hooks/QueryHooksDashboard";
import { generateFetchDataPayload, getDigitClass } from "./util";

export default function UnreadMessagesBadge({
    filterIntake,
    filterLearningMethod,
    filterLecturer,
    filterSchool
}) {
    const filters = useMemo(
        () =>
            generateFetchDataPayload({
                filterIntake,
                filterSchool,
                filterLearningMethod,
                filterLecturer
            }),
        [
            filterIntake,
            filterSchool,
            filterLearningMethod,
            filterLecturer
        ]
    );

    const {
        data: unreadMessages,
        isLoading,
        isError
    } = useUnreadCourseNotificationCount(filters);

    const countClass = useMemo(() => getDigitClass(unreadMessages), [unreadMessages]);

    if (isLoading) {
        return (
            <span className="dashboard-loading">
                <i className="fas fa-cog fa-spin"></i>
            </span>
        );
    }

    if (isError || !unreadMessages) {
        // Nothing rendered after failed retries:
        return null;
    }

    return (
        <span className="nav-fa-comments" title="You have unread messages">
            <small className={`notify-count ${countClass}`}>{unreadMessages}</small>
            <i className="fal fa-comments comments"></i>
        </span>
    );
}
